"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    xs: 480,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1600,
};
